import React, { Component } from 'react';
import moment from 'moment';
import 'moment-timezone';
import Highcharts from 'highcharts/highstock';
import ReactHighcharts from 'react-highcharts/ReactHighstock';
import _ from 'lodash';
import './GrantChart.css';
import ToJS from '../HOC/toJS';
import { connect } from 'react-redux';
import { putChartData, resetChartData } from '../../actions';
import PropTypes from 'prop-types';

window.moment = moment;
Highcharts.setOptions({
  time: {
    timezone: 'America/New_York'
  },
  lang: {
    rangeSelectorZoom: '',
    rangeSelectorFrom: 'From:',
    rangeSelectorTo: 'To:',
    numericSymbols: [' k', ' m', 'b']
  }
});

let selectedFilter = { value: '' };

const todayDate = () => {
  let todayDate = moment.tz(new Date(), 'America/New_York');
  let today = todayDate.format('x');
  return parseInt(today);
};

const todayDateInL = () => {
  let todayDate = moment();
  let today = todayDate.format('L');
  return today;
};

const convertDateInL = inp => {
  let thisDate = moment(inp.x);
  return thisDate.format('L');
};

class BOTChart extends Component {
  state = {
    data: [],
    chartDataMonth: true,
    renderValue: true
  };

  componentDidMount() {
    this.setState((state, props) => {
      return { data: this.props.data };
    });
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {   
    return !!nextState.renderValue;
  }

  componentDidUpdate(nextProps, prevState) {
    if (this.props.dataAll !== prevState.data && this.props.dataAll.length) {
      this.setState({ data: this.props.dataAll });
    }
  }

  chartDataRender = data => {
    if (data.length > 2 && this.state.chartDataMonth === false) {
      this.setState({
        chartDataMonth: true
      });
    } else if (data.length <= 2 && this.state.chartDataMonth) {
      this.setState({
        chartDataMonth: false
      });
    }
  };

  selected = data => {
    if (data && data.length !== 0) {
      let d = moment()
        .subtract(365, 'days')
        .format('x');
      d = parseInt(d);
      let oneYearData = _.filter(data, function(o) {
        return o.x <= d;
      });
      if (oneYearData.length > 0) {
        selectedFilter.value = 3;
      } else {
        selectedFilter.value = 0;
      }
    }
    return selectedFilter.value;
  };

  handleData = res => {
    // adding time fixes
    res.forEach(function(timestamp) {
      let zone = 'America/New_York';
      let newDT = moment(timestamp.x).tz(zone);
      let znx = newDT.startOf('day').format();
      let newTimeStamp = moment(znx).unix() * 1000;
      timestamp.x = newTimeStamp;
    });
    let graphObj = {};
    let graphData = [];
    for (let itr = 0; itr < res.length; itr++) {
      if (res[itr].issuedate !== null) {
        let issuedate = moment(moment(res[itr].issuedate)).format('L');
        if (graphObj.hasOwnProperty(issuedate) === false) {
          Object.defineProperty(graphObj, issuedate, {
            value: {
              x: res[itr].issuedate,
              y: res[itr].amount,
              z: [].concat(res[itr])
            },
            writable: true,
            enumerable: true
          });
        } else {
          graphObj[issuedate].y = graphObj[issuedate].y + res[itr].amount;
          graphObj[issuedate].z = [...graphObj[issuedate].z, res[itr]];
        }
      }
    }
    Object.keys(graphObj).forEach(function(key) {
      graphData.push({
        x: graphObj[key].x,
        y: graphObj[key].y,
        z: graphObj[key].z,
        date: moment(graphObj[key].x).format('DD/MM/YYYY')
      });
    });
    if (graphData && graphData.length !== 0) {
      if (this.props.data_y5 || this.props.data_all_y5) {
        graphData.unshift({
          x: parseInt(
            moment()
              .subtract(5, 'years')
              .format('x')
          ),
          y: 0,
          z: []
        });
      }
      let updatedGraphData = _.sortBy(graphData, ['x']);
      // adding last
      if (
        todayDateInL() !==
        convertDateInL(updatedGraphData[updatedGraphData.length - 1])
      ) {
        for (let i = 0; i < 4; i++) {
          updatedGraphData.push({
            x: todayDate(),
            y: 0,
            z: [],
            date: moment(todayDate()).format('DD/MM/YYYY')
          });
        }
      } else {
        let lastPlot = updatedGraphData[updatedGraphData.length - 1];
        for (let i = 0; i < 4; i++) {
          updatedGraphData.push(lastPlot);
        }
      }
      this.selected(updatedGraphData);
      this.chartDataRender(updatedGraphData);
      return updatedGraphData;
    } else {
      this.chartDataRender(graphData);
    }
  };

  tooltipGenerater = () => {
    setTimeout(function() {
      for (
        let i = 0;
        i <
        document.getElementsByClassName(
          'highcharts-axis-labels highcharts-xaxis-labels'
        )[1].childNodes.length;
        i++
      ) {
        document
          .getElementsByClassName(
            'highcharts-axis-labels highcharts-xaxis-labels'
          )[1]
          .childNodes[i].setAttribute(
            'title',
            document.getElementsByClassName(
              'highcharts-axis-labels highcharts-xaxis-labels'
            )[1].childNodes[i].innerText
          );
      }
    }, 400);
  };

  render() {
    const chartConfig = {
      chart: {
        type: 'area',
        panning: false,
        pinchType: false,
        events: {
          load: function() {
            setTimeout(function() {
              const obj = document.getElementsByClassName('highcharts-axis-labels highcharts-xaxis-labels');
              if(obj && obj.length > 0) {
                for (let i = 0; i < obj[1].childNodes.length; i++) {                  
                  obj[1].childNodes[i].setAttribute('title', obj[1].childNodes[i].innerText);
                }
              }
            }, 400);

            document.addEventListener('scroll', function() {
              const elm = document.getElementsByClassName('range-selector-tooltip');
              if(elm && elm.length > 0){
                elm[0].style.display = 'none';
              }              
            });

            document.getElementsByClassName(
              'range-selector-tooltip'
            )[0].style.display = 'none';

            if (
              navigator.userAgent.indexOf('Safari') != -1 &&
              navigator.userAgent.indexOf('Chrome') === -1
            ) {
              let windowWidth = window.innerWidth;

              if (windowWidth > 767) {
                document
                  .getElementsByClassName('highcharts-button')[0]
                  .childNodes[1].setAttributeNS(null, 'y', 15);
                document
                  .getElementsByClassName('highcharts-button')[3]
                  .childNodes[1].setAttributeNS(null, 'y', 16);

                setTimeout(function() {
                  document
                    .getElementsByClassName(
                      'highcharts-range-selector-buttons'
                    )[0]
                    .childNodes[0].setAttributeNS(null, 'x', 55);
                  
                }, 100);
              } else {
                return 0;
              }
            }
            let ua = window.navigator.userAgent;

            let msie = ua.indexOf('MSIE ');
            if (msie > 0) {
              let windowWidth = window.innerWidth;
              // IE 10 => return version number
              if (windowWidth > 767) {
                setTimeout(function() {
                  document
                    .getElementsByClassName(
                      'highcharts-range-selector-buttons'
                    )[0]
                    .childNodes[0].setAttributeNS(null, 'y', 20);

                  
                  document
                    .getElementsByClassName(
                      'highcharts-label highcharts-range-label'
                    )[0]
                    .childNodes[0].setAttributeNS(null, 'x', -5);
                  document
                    .getElementsByClassName(
                      'highcharts-label highcharts-range-label'
                    )[1]
                    .childNodes[0].setAttributeNS(null, 'x', -2);
                  document
                    .getElementsByClassName(
                      'highcharts-label highcharts-range-label'
                    )[0]
                    .childNodes[0].setAttributeNS(null, 'y', 16);
                  document
                    .getElementsByClassName(
                      'highcharts-label highcharts-range-label'
                    )[1]
                    .childNodes[0].setAttributeNS(null, 'y', 17);
                }, 100);
              } else {
                for (
                  let i = 0;
                  i <
                  document.getElementsByClassName('highcharts-button').length;
                  i++
                ) {
                  document
                    .getElementsByClassName('highcharts-button')
                    [i].childNodes[1].setAttributeNS(null, 'x', 10);
                }
                setTimeout(function() {
                  document
                    .getElementsByClassName(
                      ' highcharts-range-selector-buttons'
                    )[0]
                    .setAttribute('transform', 'translate(-15 10)');

                  document
                    .getElementsByClassName('highcharts-input-group')[0]
                    .setAttribute('transform', 'translate(0 48)');
                  document
                    .getElementsByClassName(
                      'highcharts-label highcharts-range-label'
                    )[0]
                    .childNodes[0].setAttributeNS(null, 'y', 16);
                  document
                    .getElementsByClassName(
                      'highcharts-label highcharts-range-label'
                    )[1]
                    .childNodes[0].setAttributeNS(null, 'y', 16);
                }, 100);
              }
            }

            let trident = ua.indexOf('Trident/');
            if (trident > 0) {
              let windowWidth = window.innerWidth;
              // IE 11 => return version number
              if (windowWidth > 767) {

                setTimeout(function() {
                  document
                    .getElementsByClassName(
                      'highcharts-range-selector-buttons'
                    )[0]
                    .childNodes[0].setAttributeNS(null, 'y', 20);
                  document
                    .getElementsByClassName(
                      'highcharts-label highcharts-range-label'
                    )[0]
                    .childNodes[0].setAttributeNS(null, 'x', -5);
                  document
                    .getElementsByClassName(
                      'highcharts-label highcharts-range-label'
                    )[1]
                    .childNodes[0].setAttributeNS(null, 'x', -2);
                  document
                    .getElementsByClassName(
                      'highcharts-label highcharts-range-label'
                    )[0]
                    .childNodes[0].setAttributeNS(null, 'y', 16);
                  document
                    .getElementsByClassName(
                      'highcharts-label highcharts-range-label'
                    )[1]
                    .childNodes[0].setAttributeNS(null, 'y', 17);
                }, 200);
              } else {
                for (
                  let i = 0;
                  i <
                  document.getElementsByClassName('highcharts-button').length;
                  i++
                ) {
                  document
                    .getElementsByClassName('highcharts-button')
                    [i].childNodes[1].setAttributeNS(null, 'x', 10);
                }
                setTimeout(function() {
                  document
                    .getElementsByClassName(
                      ' highcharts-range-selector-buttons'
                    )[0]
                    .setAttribute('transform', 'translate(-15 10)');

                  document
                    .getElementsByClassName('highcharts-input-group')[0]
                    .setAttribute('transform', 'translate(0 48)');
                  document
                    .getElementsByClassName(
                      'highcharts-label highcharts-range-label'
                    )[0]
                    .childNodes[0].setAttributeNS(null, 'y', 16);
                  document
                    .getElementsByClassName(
                      'highcharts-label highcharts-range-label'
                    )[1]
                    .childNodes[0].setAttributeNS(null, 'y', 16);
                }, 200);
              }
            }

            let edge = ua.indexOf('Edge/');
            if (edge > 0) {
              // Edge (IE 12+) => return version number
            }
            const arr = document.getElementsByClassName(
              'highcharts-button-disabled'
            );

            for (let i = 0; i < arr.length; i++) {
              arr[i].addEventListener('mouseover', function() {
                let pos = this.getBoundingClientRect();
                document.getElementsByClassName(
                  'range-selector-tooltip'
                )[0].style.display = 'inline-block';

                document.getElementsByClassName(
                  'range-selector-tooltip'
                )[0].style.top = pos.top - 90 + 'px';
                document.getElementsByClassName(
                  'range-selector-tooltip'
                )[0].style.left = pos.left - 78 + 'px';
              });

              arr[i].addEventListener('mouseout', function() {
                let pos = this.getBoundingClientRect();
                document.getElementsByClassName(
                  'range-selector-tooltip'
                )[0].style.display = 'none';
              });
            }
            for (let i = 0; i < arr.length; i++) {
              arr[i].addEventListener('touchstart', function() {
                let pos = this.getBoundingClientRect();
                document.getElementsByClassName(
                  'range-selector-tooltip'
                )[0].style.display = 'inline-block';
                document.getElementsByClassName(
                  'range-selector-tooltip'
                )[0].style.top = pos.top - 90 + 'px';
                document.getElementsByClassName(
                  'range-selector-tooltip'
                )[0].style.left = pos.left - 78 + 'px';
              });

              arr[i].addEventListener('touchend', function() {
                document.getElementsByClassName(
                  'range-selector-tooltip'
                )[0].style.display = 'none';
              });
            }
          }
        }
      },

      rangeSelector: {
        inputEnabled: true,
        inputDateFormat: '%m/%d/%Y',
        inputEditDateFormat: '%m/%d/%Y',
        inputBoxBorderColor: 'tranparent',
        inputBoxWidth: 80,
        inputBoxHeight: 20,
        inputStyle: {
          color: '#505050',
          fontFamily: 'HelveticaNeue-Bold',
          letterSpacing: 0.5,
          fontSize: '16px'
        },
        labelStyle: {
          color: '#505050',
          fontFamily: 'HelveticaNeue',
          fontSize: '16px'
        },

        buttons: [
          {
            type: 'month',
            count: 1,
            text: '1M',
            events: {
              click: () => {
                this.props.handleFilterAnalytics('botEvents', '', '1M');
                selectedFilter.value = 0;
                this.tooltipGenerater();
              }
            }
          },
          {
            type: 'month',
            count: 3,
            text: '3M',
            events: {
              click: () => {
                this.props.handleFilterAnalytics('botEvents', '', '3M');
                selectedFilter.value = 1;
              }
            },
            offsetMin: (function() {
              if (moment.tz.guess(true) != 'America/New_York') {
                return 1 * 3600 * 1000;
              }
            })()
          },
          {
            type: 'month',
            count: 6,
            text: '6M',
            events: {
              click: () => {
                this.props.handleFilterAnalytics('botEvents', '', '6M');
                selectedFilter.value = 2;
                this.tooltipGenerater();
              }
            }
          },
          {
            type: 'year',
            count: 1,
            text: '1Y',
            events: {
              click: () => {
                this.props.handleFilterAnalytics('botEvents', '', '1Y');
                selectedFilter.value = 3;
                this.tooltipGenerater();
              }
            }
          },
          {
            type: 'year',
            count: 3,
            text: '3Y',
            events: {
              click: () => {
                this.props.handleFilterAnalytics('botEvents', '', '3Y');
                selectedFilter.value = 4;
                this.tooltipGenerater();
              }
            }
          },
          {
            type: 'year',
            count: 5,
            text: '5Y',
            events: {
              click: () => {
                this.props.handleFilterAnalytics('botEvents', '', '5Y');
                selectedFilter.value = 5;
                this.tooltipGenerater();
              }
            }
          }
        ],
        selected: selectedFilter.value,
        buttonTheme: {
          fill: 'none',
          stroke: 'none',
          'stroke-width': 0,
          r: 4,
          padding: 5,
          style: {
            fontFamily: 'HelveticaNeue-Medium',
            fontWeight: 'normal',
            fontSize: '16px',
            position: 'absolute',
            textAlign: 'center',
            color: '#606060',
            borderColor: '#000000'
          },
          states: {
            hover: {
              fill: '#0d504d',
              style: {
                color: 'white',
                fontFamily: 'HelveticaNeue-Medium',
                fontSize: '16px',
                paddingTop: '2px',
                fontWeight: 'normal',
                fontStyle: 'normal',
                textAlign: 'center'
              }
            },
            select: {
              fill: '#0d504d',
              style: {
                color: 'white',
                fontFamily: 'HelveticaNeue-Medium',
                fontSize: '16px',
                paddingTop: '12px',
                fontWeight: 'normal',
                fontStyle: 'normal',
                fontStretch: 'normal',
                lineHeight: 'normal',
                letterSpacing: 'normal',
                textAlign: 'center'
              }
            },
            disabled: {
              fill: '#eaeaea',
              style: {
                fontFamily: 'HelveticaNeue-Medium',
                fontSize: '16px',
                position: 'absolute',
                fontStyle: 'normal',
                fontStretch: 'normal',
                lineHeight: 'normal',
                letterSpacing: 'normal',
                textAlign: 'center',
                color: '#606060',
                fontWeight: 'normal'
              }
            }
          }
        }
      },
      navigator: {
        enabled: true
      },

      yAxis: {
        opposite: false,
        maxPadding: 0.1,
        labels: (function() {
          let windowWidth = window.innerWidth;
          if (windowWidth > 767) {
            let obj = {
              style: {
                color: '#505050',
                fontFamily: 'HelveticaNeue',
                fontSize: '14px'
              },

              formatter: function() {
                return '$' + this.axis.defaultLabelFormatter.call(this);
              }
            };
            return obj;
          } else {
            let obj = {
              align: 'left',
              x: -10,
              y: -2,
              style: {
                color: '#505050',
                fontFamily: 'HelveticaNeue',
                fontSize: '12px'
              },
              formatter: function() {
                return '$' + this.axis.defaultLabelFormatter.call(this);
              }
            };
            return obj;
          }
        })()
      },

      xAxis: {
        ordinal: false,
        labels: (function() {
          let windowWidth = window.innerWidth;
          if (windowWidth > 767) {
            let obj = {
              useHTML: true,
              style: {
                color: '#505050',
                fontFamily: 'HelveticaNeue',
                fontSize: '14px'
              }
            };
            return obj;
          } else {
            let obj = {
              style: {
                color: '#505050',
                fontFamily: 'HelveticaNeue',
                fontSize: '12px'
              }
            };
            return obj;
          }
        })(),

        type: 'datetime',
        dateTimeLabelFormats: {
          millisecond: {
            main: '%H:%M:%S.%L',
            range: false
          },
          second: {
            main: '%H:%M:%S',
            range: false
          },
          minute: {
            main: '%H:%M',
            range: false
          },
          hour: {
            main: '%H:%M',
            range: false
          },
          day: {
            main: '%b %d '
          },
          week: {
            main: '%b %d '
          },
          month: {
            month: "%b '%y"
          },
          year: '%Y'
        }
      },

      plotOptions: {
        series: {
          turboThreshold: 0,
          cursor: 'pointer',
          showInNavigator: true,
          fillOpacity: 0.4,
          lineWidth: 1.5,
          lineColor: '#136878',
          dataLabels: {
            crop: false,
            overflow: 'allow'
          },
          point: {
            events: {
              click: function(event) {
                makeData(event);
              }
            }
          },
          states: {
            hover: {
              halo: {
                size: 9,
                opacity: 0.2,
                color: '#006778'
              }
            }
          }
        }
      },
      tooltip: {
        backgroundColor: 'white',
        borderWidth: 1.5,
        borderColor: '#006778',
        shadow: false,
        useHTML: true,
        style: {
          padding: 20,
          color: '#4a4a4a'
        },
        formatter: function(e) {
          let toolTip = document.getElementsByClassName('highcharts-tooltip');
          let toolTipEle = document.getElementsByClassName('bot-chart-tooltip');
          if (
            (moment().format('L') === moment(this.x).format('L') &&
              this.y === '0') ||
            this.y === '0'
          ) {
            if (toolTip[0] && toolTipEle[0]) {
              toolTip[0].style.visibility = 'hidden';
              toolTipEle[0].style.visibility = 'hidden';
            }
            return null;
          } else {
            if (toolTip[0] && toolTipEle[0]) {
              toolTip[0].style.visibility = 'visible';
              toolTipEle[0].style.visibility = 'visible';
            }
            return (
              "<div class='bot-chart-tooltip'> " +
              "<div class='bot-chart-heading'>" +
              '<b>' +
              moment(this.x).format('L') +
              '</b>' +
              '</div>' +
              '<div class="grant-text">' +
              'Total:' +
              '&nbsp' +
              '<b>' +
              '$' +
              Number(this.y).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }) +
              '</b>' +
              '</div>' +
              '<div class="grant-text">' +
              'No.of Grants:' +
              '&nbsp' +
              '<b>' +
              Number(e.chart.hoverPoint.z.length) +
              '</b>' +
              '</div>' +
              '</div>'
            );
          }
        }
      },
      series: [
        {
          name: 'BOT',
          data: this.handleData(this.state.data),
          id: 'dataseries',
          color: '#d9e8eb'
        }
      ]
    };

    const makeData = event => {
      if (event.point.z.length !== 0) {
        const chartData = {
          x: event.point.x,
          y: event.point.y,
          z: event.point.z
        };
        this.setState({ renderValue: false });
        this.props.storeChartData(chartData);
      } else {
        this.props.resetChart();
      }
    };
    return (
      <div>
        {this.state.chartDataMonth === false ? (
          <div className='grants-dashboard noDataPlacement chart-no-data'>
            <div>You currently have no grant activity.</div>
          </div>
        ) : (
          <div className='grant-chart'>
            <div className='view-range-text'>View Range</div>
            <ReactHighcharts highcharts={Highcharts} config={chartConfig} />
            <div className='range-selector-tooltip'>
              {this.props.botStatusText}
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  storeChartData: data => dispatch(putChartData(data)),
  resetChart: () => dispatch(resetChartData())
});

export default ToJS(
  connect(
    null,
    mapDispatchToProps
  )(BOTChart)
);


BOTChart.propTypes = {
  storeChartData: PropTypes.func,
  resetChart: PropTypes.func,
  additionalDetails: PropTypes.object,
  botStatusText: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.number,
      availableBalance: PropTypes.number,
      charityName: PropTypes.string,
      currentBalance: PropTypes.number,
      dateRequested: PropTypes.number,
      dpUser: PropTypes.string,
      dpUserFirstName: PropTypes.string,
      dpUserLastName: PropTypes.string,
      dpUserMiddleName: PropTypes.string,
      dpUserPrefix: PropTypes.string,
      dpUserSuffix: PropTypes.string,
      grantAgreement: PropTypes.bool,
      interestArea: PropTypes.string,
      isRecurring: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      issuedate: PropTypes.number,
      purpose: PropTypes.string,
      purposeAdditionalComment: PropTypes.string,
      status: PropTypes.string,
      txnId: PropTypes.number,
      userName: PropTypes.string,
      x: PropTypes.number,
      y3: PropTypes.bool,
      y5: PropTypes.bool,
    })
  ),
  dataAll: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.number,
      availableBalance: PropTypes.number,
      charityName: PropTypes.string,
      currentBalance: PropTypes.number,
      dateRequested: PropTypes.number,
      dpUser: PropTypes.string,
      dpUserFirstName: PropTypes.string,
      dpUserLastName: PropTypes.string,
      dpUserMiddleName: PropTypes.string,
      dpUserPrefix: PropTypes.string,
      dpUserSuffix: PropTypes.string,
      grantAgreement: PropTypes.bool,
      interestArea: PropTypes.string,
      isRecurring: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      issuedate: PropTypes.number,
      purpose: PropTypes.string,
      purposeAdditionalComment: PropTypes.string,
      status: PropTypes.string,
      txnId: PropTypes.number,
      userName: PropTypes.string,
      x: PropTypes.number,
      y3: PropTypes.bool,
      y5: PropTypes.bool,
    })
  ),
  data_all_y5: PropTypes.bool,
  data_y5: PropTypes.bool,
  handleFilterAnalytics: PropTypes.func,
  isAllGrantsLoading: PropTypes.bool,
};